export { default as parseColor } from './color/parse-color';
export { default as namedColors } from './color/named-colors';
export { default as Color } from './color/color';